import React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import UICard from "./UICard";

const UITableWrapper = ({
  title,
  subtitle,
  actions,
  children,
  cardProps,
  contentSx,
}) => {
  return (
    <UICard
      {...cardProps}
      contentSx={{
        p: 0,
        "&:last-child": {
          pb: 0,
        },
        ...contentSx,
      }}
    >
      {(title || subtitle || actions) && (
        <Stack
          direction={{ xs: "column", md: "row" }}
          alignItems={{ xs: "flex-start", md: "center" }}
          justifyContent="space-between"
          spacing={2}
          sx={{ px: 3, pt: 3, pb: 2 }}
        >
          <Box>
            {title ? (
              <Typography variant="h6" color="text.primary">
                {title}
              </Typography>
            ) : null}
            {subtitle ? (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                {subtitle}
              </Typography>
            ) : null}
          </Box>
          {actions ? <Stack direction="row" spacing={1}>{actions}</Stack> : null}
        </Stack>
      )}
      <Box sx={{ px: 3, pb: 3 }}>{children}</Box>
    </UICard>
  );
};

export default UITableWrapper;
